import { render, staticRenderFns } from "./historical-arbitrage-inquiry.vue?vue&type=template&id=0239c828&scoped=true&"
import script from "./historical-arbitrage-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-arbitrage-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-arbitrage-inquiry.vue?vue&type=style&index=0&id=0239c828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239c828",
  null
  
)

export default component.exports